
export default {
  name: "sidebar",
  data: () => ({
    miniSide: false,
    items: [
      {
        action: "mdi-account-multiple",
        title: "Dashboard",
        path: "/test",
        includeList: true,
        list: [
          { title: "Admin Dashboard", path: "/gergt" },
          { title: "Employee Dashboard", path: "/geet" },
        ],
      },
      {
        action: "mdi-silverware-fork-knife",
        title: "Apps",
        includeList: true,
        list: [{ title: "All employees", path: "/page" }],
      },
    ],
    boards: [
      {
        action: "mdi-account-tie",
        title: "employees",
        path: "/employees",
        includeList: true,
        list: [
          { title: "All employees", path: "/employees/all" },
          { title: "Department", path: "/Department" },
        ],
      },
      {
        action: "mdi-account-group",
        title: "Clients",
        path: "/clients",
        includeList: false,
      },
      {
        action: "mdi-rocket-launch-outline",
        title: "Projects",
        // path: "/",
        includeList: true,
        list: [
          { title: "All employees", path: "/page11" },
          { title: "All employees", path: "/page11" },
        ],
      },
      {
        action: "mdi-account-multiple",
        title: "Leads",
        path: "leads",
        includeList: false,
      },
      {
        action: "mdi-ticket-outline",
        title: "Tickets",
        path: "tickets",
        includeList: false,
      },
    ],
  }),
  watch: {
    "$store.state.drawerAll": {
      deep: true, // for arrays and objects
      handler() {
        const that = this as any;
        that.miniSide = that.$store.state.drawerAll.mini;
      },
    },
    "$vuetify.breakpoint.name": {
      immediate: true, // بتشتغل اول ما الصفحة تحمل
      deep: true, // for arrays and objects
      handler(): any {
        const that = this as any;
        const val = that.$vuetify.breakpoint.name;
        let drawer = Object.assign({}, that.$store.state.drawerAll); // copy of the object

        if (val == "xs" || val == "sm" || val == "md") {
          drawer.view = false;
        } else {
          drawer.view = true;
        }
        that.$store.commit("get_drawer", drawer);
      },
    },
  },
  methods: {
    open() {
      const that = this as any;
      const drawer = that.$store.state.drawerAll;
      if (drawer.mini) {
        that.miniSide = false;
      }
    },
    close() {
      const that = this as any;
      const drawer = that.$store.state.drawerAll;
      if (drawer.mini) {
        that.miniSide = true;
      }
    },
    // changg() {
    //   const width = window.innerWidth;
    //   if (width <= 991) {

    //   }
    // }
  },
};
